// extracted by mini-css-extract-plugin
export var circle = "_40-2";
export var icon = "_40-a";
export var iconHighlight = "_40-0";
export var lg = "_40-8";
export var md = "_40-7";
export var outline = "_40-4";
export var sm = "_40-6";
export var square = "_40-1";
export var xl = "_40-9";
export var xs = "_40-5";
export var xxs = "_40-3";